import '../../styles/button/delete-button.css'
import {ReactComponent as TrashIcon} from '../../../../images/admin-icons/trash-modal-delete.svg'
const DeleteButton = ({children,action,disabled}) => {
  return (
    <button 
      onClick={action} 
      className='delete-button' 
      disabled={disabled}
    ><TrashIcon/>{children}</button>
  )
}

export default DeleteButton